import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ar-payment-form',
  templateUrl: './ar-payment-form.component.html',
  styleUrls: ['./ar-payment-form.component.css']
})
export class ArPaymentFormComponent implements OnInit {
  title="Accounts Receivable Payment";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component.ts